export default __webpack_public_path__ + "static/media/carlos.913bc267.png";